import React from 'react';
import { Box, Typography } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const WhatsAppFloat: React.FC = () => {
  const whatsappUrl =
    'https://wa.me/919116033575?text=Hi%20Fingard%20Partners%2C%20I%20would%20like%20to%20inquire%20about%20your%20services.';

  return (
    <Box
      component="a"
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp Us"
      sx={{
        position: 'fixed',
        bottom: 0, // Placed flat on the bottom edge
        right: 0,  // Placed flat on the right edge
        bgcolor: '#25D366',
        color: '#fff',
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 3,
        py: 1.8,
        // Match the image: top-left and top-right are rounded, bottom and right are flat
        borderRadius: '16px 0 0 0', 
        boxShadow: '-4px -4px 16px rgba(0, 0, 0, 0.08)',
        zIndex: 10000,
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          bgcolor: '#20ba5a',
          paddingLeft: '28px', // Subtle shifting feedback
        },
      }}
    >
      <WhatsAppIcon sx={{ fontSize: 26 }} />
      <Typography 
        variant="button" 
        sx={{ 
          fontWeight: 600, 
          fontSize: '0.95rem', 
          textTransform: 'none',
          lineHeight: 1,
          letterSpacing: '0.2px',
          fontFamily: 'inherit'
        }}
      >
        Live Chat with Experts
      </Typography>
    </Box>
  );
};

export default WhatsAppFloat;
